interface HeaderBackgroundProps {
  className?: string;
  blur?: number;
}

/**
 * Reusable header background component with blurred twilight image
 * Can be used across all header components for consistent styling
 */
export default function HeaderBackground({ className = '', blur = 30 }: HeaderBackgroundProps) {
  return (
    <div
      className={`absolute ${className}`}
      style={{
        top: `-${blur * 2}px`,
        left: `-${blur * 2}px`,
        right: `-${blur * 2}px`,
        bottom: `-${blur * 2}px`,
        backgroundImage: 'url(/images/twilight.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: `blur(${blur}px)`
      }}
    />
  );
}
